(function () {
    'use strict';
    /*
     * Copyright (c) 2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('EpisodeTemplateCtrl', EpisodeTemplateCtrl);

    EpisodeTemplateCtrl.$inject = ['CampaignConstants', 'ObserverService', '_', 'EpisodeTemplateConstants', '$q'];

    function EpisodeTemplateCtrl (CampaignConstants, ObserverService, _, EpisodeTemplateConstants, $q) {
        var vm = this;
        var allTabsUnselected = {
            glance: false,
            messages: false,
            prescription: false,
            resourceMaterials: false
        };
        var selectedTabDefault = {
            glance: true
        };
        var CampaignConstantsForm = CampaignConstants.form;

        vm.tabState = {};
        vm.isSelectedTab = isSelectedTab;
        vm.selectTab = selectTab;
        vm.edit = edit;
        vm.save = save;
        vm.cancel = cancel;
        vm.remove = remove;
        vm.toggleCollapsed = toggleCollapsed;

        /*
         * ihh form ignores is used to specify DOM element IDs that should not influence the form alert banner.
         * This is because these form elements are invalid, but represent an entire form, and not a specific element.
         */
        vm.ihhFormIgnores = [CampaignConstantsForm.campaignGlanceForm,
            CampaignConstantsForm.campaignMessagesForm,
            CampaignConstantsForm.CampaignPrescriptionForm,
            CampaignConstantsForm.campaignResourceMaterialsForm];

        vm.TABS = {
            glance: 'glance',
            messages: 'messages',
            prescription: 'prescription',
            resourceMaterials: 'resourceMaterials'
        };

        activate();

        function activate () {
            vm.tabState = getDefaultTabSelected();
            vm._expanded = true;

            if (!vm.episodeModel.id) {
                isEdit(true);
            }

            registerObserverCallbacks();
        }

        function toggleCollapsed () {
            vm._expanded = !vm._expanded;
        }

        function getDefaultTabSelected () {
            return angular.extend(allTabsUnselected, selectedTabDefault);
        }

        function isSelectedTab (tab) {
            return vm.tabState[tab];
        }

        function selectTab (tab) {
            var tabs = angular.copy(allTabsUnselected);

            allTabsUnselected[tab] = true;

            vm.tabState = tabs;
        }

        function getActiveTab () {
            var tabs = Object.keys(vm.tabState);
            var tab;
            var tabName;
            var activeTab;
            var tabIndex;

            for (tabIndex = 0; tabIndex < tabs.length; tabIndex++) {
                tabName = tabs[tabIndex];
                tab = vm.tabState[tabName];
                if (tab) {
                    activeTab = tabName;
                    break;
                }
            }

            return activeTab;
        }

        function edit () {
            isEdit(true);

            ObserverService.notifyObservers(CampaignConstants.observers[getActiveTab()].edit, {});
        }

        function registerObserverCallbacks() {
            ObserverService.registerObserverCallback(CampaignConstants.observers.form.formReady, function (theForm) {
                vm.episodeTemplateForm = theForm;
            });

            ObserverService.registerObserverCallback(EpisodeTemplateConstants.observers.form.displayBusyIndicator, displayBusyIndicator);
            ObserverService.registerObserverCallback(EpisodeTemplateConstants.observers.form.hideBusyIndicator, hideBusyIndicator);
        }

        // uses a promise to display the busy indicator
        function displayBusyIndicator () {
            vm.episodeTemplateFormPromise = $q.defer().promise; // false promise
        }

        // clears the promise so that the busy indicator will no longer be displayed
        function hideBusyIndicator () {
            vm.episodeTemplateFormPromise = null;
        }

        function cancel () {
            isEdit(false);

            if (!vm.episodeModel.id) {
                ObserverService.notifyObservers(CampaignConstants.observers.page.cancelEpisodeTemplate, {});
            }
            else {
                ObserverService.notifyObservers(CampaignConstants.observers[getActiveTab()].cancel, {});
            }
        }

        function save () {
            ObserverService.notifyObservers(CampaignConstants.observers[getActiveTab()].save, {});
        }

        function remove () {
            ObserverService.notifyObservers(CampaignConstants.observers[getActiveTab()].remove, {});
        }

        /**
         * Updates the isEdit value with any value passed, and returns the current value.
         *
         * @param {Boolean} val - if sent, sets the isEdit value
         * @returns {Boolean} the current value of isEdit
         */
        function isEdit (val) {
            if (val === true || val === false) {
                vm.isEdit = val;
            }

            return vm.isEdit;
        }
    }
})();
